import Reveal from '@/components/base/Reveal';
import { conceptImage, concepts } from '@/mocks/site';

export default function Concept() {
  return (
    <section id="concept" className="border-t border-background-200/60 bg-background-50 px-5 py-16 pr-14 md:px-10 md:py-24 md:pr-20">
      <div className="mx-auto max-w-6xl">
        <div className="grid items-start gap-10 md:grid-cols-12 md:gap-14">
          <div className="md:col-span-6 md:pt-4">
            <Reveal variant="up">
              <div className="flex items-center gap-3">
                <span className="h-px w-8 bg-primary-500" />
                <p className="text-[10px] en-label text-primary-600">CONCEPT</p>
              </div>
              <h2 className="mt-5 font-heading text-[27px] font-black leading-[1.35] tracking-[-0.01em] text-foreground-950 sm:text-[34px] md:text-[42px]">
                いつもの場所に、
                <br />
                もう一度、人が集まる。
              </h2>
            </Reveal>

            <Reveal variant="up" delay={150}>
              <p className="mt-6 text-[13px] leading-[2.1] text-foreground-700 md:text-[14px]">
                買い物に来たはずの駐車場が、屋台の灯りと匂いでいっぱいになる。特別なことをしなくても、同じ場所に集まるだけで空気は変わっていきます。
              </p>
              <p className="mt-4 text-[13px] leading-[2.1] text-foreground-600 md:text-[14px]">
                トライアルフェスタは、熊本県内のトライアル各店舗で開催する復興イベントです。地域のお店や作り手が出店し、家族連れがふらっと立ち寄れる。そんな日常の延長にある賑わいを、店舗を変えながら続けています。
              </p>
            </Reveal>

            <Reveal variant="up" delay={260} className="mt-8 rounded-md border border-background-300/80 bg-background-100/70 p-5 md:mt-10">
              <p className="text-[11px] en-label text-secondary-700">OUR PURPOSE</p>
              <p className="mt-2.5 font-heading text-[14px] font-bold leading-relaxed text-foreground-900 md:text-[15px]">
                地域の賑わいを、次の世代へつなぐ。
              </p>
              <p className="mt-2 text-[12px] leading-[1.9] text-foreground-600">
                出店者・出演者・協賛企業・来場者。関わるすべての人が主役になれる場を、熊本から広げていきます。
              </p>
            </Reveal>
          </div>

          <div className="md:col-span-6">
            <Reveal variant="mask" duration={1200} className="overflow-hidden rounded-lg">
              <div className="h-[300px] w-full overflow-hidden sm:h-[420px] md:h-[520px]">
                <img
                  src={conceptImage}
                  alt="トライアルフェスタの会場でキッチンカーの準備をする出店者"
                  className="animate-ken-burns h-full w-full object-cover"
                />
              </div>
            </Reveal>
            <Reveal variant="fade" delay={200} className="mt-3 flex items-center justify-between">
              <p className="text-[11px] text-foreground-500">会場の空気をつくる、運営の仕事。</p>
              <p className="text-[10px] en-label text-foreground-400">PHOTO: IMAGE</p>
            </Reveal>
          </div>
        </div>

        <div className="mt-12 grid gap-0 border-t border-background-300 md:mt-16 md:grid-cols-3">
          {concepts.map((item, index) => (
            <Reveal
              key={item.title}
              variant="up"
              delay={index * 120}
              className={`border-b border-background-300 py-7 md:border-b-0 md:py-8 ${
                index !== 0 ? 'md:border-l md:border-background-300 md:pl-8' : ''
              } ${index !== concepts.length - 1 ? 'md:pr-8' : ''}`}
            >
              <span className="mb-4 block h-px w-9 bg-primary-500" />
              <div className="flex items-baseline gap-3">
                <h3 className="font-heading text-[17px] font-black text-foreground-950 md:text-[19px]">{item.title}</h3>
                <span className="ml-auto text-[9px] en-label text-foreground-400 md:ml-3">{item.sub}</span>
              </div>
              <p className="mt-3 text-[12.5px] leading-[1.95] text-foreground-600">{item.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}